{
  "name": "ggplayer",
  "version": "4.0.0",
  "type": "module",
  "main": "dist/ggplayer.umd.js",
  "module": "dist/ggplayer.es.js",
  "types": "dist/types/index.d.ts",
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && vite build",
    "build:lite": "tsc --noEmit && cross-env BUILD_TARGET=lite vite build",
    "build:standalone": "tsc --noEmit && cross-env BUILD_TARGET=standalone vite build",
    "build:all": "npm run build && npm run build:lite && npm run build:embed",
    "build:embed": "tsc --noEmit && cross-env BUILD_TARGET=embed vite build",
    "build:integration": "npm run build:standalone && npm run copy",
    "build:integration:watch": "concurrently --names \"BUILD,COPY\" --colors \"cyan,magenta\" \"cross-env BUILD_TARGET=standalone vite build --watch\" \"chokidar 'dist/ggplayer.standalone.*' -c 'npm run copy'\"",
    "copy": "cp dist/ggplayer.standalone.umd.js /home/oem/gg/public/js/",
    "test": "vitest run",
    "test:all": "npm run test && npm run test:screenshots",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage --coverage.all --coverage.include=src/**/*.{ts,tsx} --coverage.exclude=src/**/*.test.{ts,tsx} --coverage.exclude=src/**/*.d.ts --coverage.exclude=src/vite-env.d.ts",
    "test:screenshots": "playwright test --config=screenshot-tests/playwright.config.ts",
    "test:screenshots:update": "playwright test --config=screenshot-tests/playwright.config.ts --update-snapshots",
    "test:screenshots:report": "playwright show-report screenshot-tests/playwright-report"
  },
  "keywords": [
    "player",
    "hls",
    "ll-hls",
    "streaming"
  ],
  "author": "",
  "license": "ISC",
  "description": "GoodGame Video/Stream Player v4",
  "devDependencies": {
    "@playwright/test": "^1.59.1",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/node": "^25.5.0",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.1.2",
    "chokidar-cli": "^3.0.0",
    "concurrently": "^9.1.2",
    "cross-env": "^10.1.0",
    "esbuild": "^0.27.4",
    "jsdom": "^29.0.0",
    "typescript": "^5.9.3",
    "vite": "^8.0.0",
    "vite-plugin-terminal": "^1.4.0",
    "vitest": "^4.1.0"
  },
  "dependencies": {
    "hls.js": "^1.6.15",
    "react": "^19.0.0",
    "react-dom": "^19.0.0"
  }
}
